/**
 * Utility functions for collecting browser metadata
 */

/**
 * Collects comprehensive browser and device metadata
 * @returns {Object} Browser metadata object
 */
export function collectBrowserMetadata() {
    try {
        const metadata = {
            // Browser information
            userAgent: navigator.userAgent,
            language: navigator.language,
            languages: navigator.languages,
            platform: navigator.platform,
            
            // Screen information
            screen: {
                // eslint-disable-next-line no-restricted-globals
                width: screen.width,
                // eslint-disable-next-line no-restricted-globals
                height: screen.height,
                // eslint-disable-next-line no-restricted-globals
                availWidth: screen.availWidth,
                // eslint-disable-next-line no-restricted-globals
                availHeight: screen.availHeight,
                // eslint-disable-next-line no-restricted-globals
                colorDepth: screen.colorDepth,
                // eslint-disable-next-line no-restricted-globals
                pixelDepth: screen.pixelDepth
            },
            
            // Window information
            window: {
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
                outerWidth: window.outerWidth,
                outerHeight: window.outerHeight,
                devicePixelRatio: window.devicePixelRatio
            },
            
            // Timezone information
            timezone: {
                offset: new Date().getTimezoneOffset(),
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            
            // Connection information (if available)
            connection: navigator.connection ? {
                effectiveType: navigator.connection.effectiveType,
                downlink: navigator.connection.downlink,
                rtt: navigator.connection.rtt,
                saveData: navigator.connection.saveData
            } : null,
            
            // Device memory (if available)
            deviceMemory: navigator.deviceMemory || null,
            
            // Hardware concurrency
            hardwareConcurrency: navigator.hardwareConcurrency,
            
            // Cookie enabled
            cookieEnabled: navigator.cookieEnabled,
            
            // Online status
            online: navigator.onLine,
            
            // Do not track
            doNotTrack: navigator.doNotTrack,
            
            // Timestamp when metadata was collected
            collectedAt: new Date().toISOString(),
            
            // URL information
            url: {
                href: window.location.href,
                origin: window.location.origin,
                pathname: window.location.pathname,
                search: window.location.search,
                hash: window.location.hash,
                hostname: window.location.hostname,
                port: window.location.port,
                protocol: window.location.protocol
            },
            
            // Referrer
            referrer: document.referrer,
            
            // Document information
            document: {
                title: document.title,
                characterSet: document.characterSet,
                readyState: document.readyState
            }
        };
        
        return metadata;
    } catch (error) {
        console.warn('Error collecting browser metadata:', error);
        return {
            error: error.message,
            collectedAt: new Date().toISOString()
        };
    }
}

/**
 * Collects minimal browser metadata (for cases where full metadata is not needed)
 * @returns {Object} Minimal browser metadata object
 */
export function collectMinimalBrowserMetadata() {
    try {
        return {
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: navigator.platform,
            screen: {
                // eslint-disable-next-line no-restricted-globals
                width: screen.width,
                // eslint-disable-next-line no-restricted-globals
                height: screen.height
            },
            timezone: new Date().getTimezoneOffset(),
            online: navigator.onLine,
            collectedAt: new Date().toISOString(),
            url: window.location.href
        };
    } catch (error) {
        console.warn('Error collecting minimal browser metadata:', error);
        return {
            error: error.message,
            collectedAt: new Date().toISOString()
        };
    }
}

